export default "__VITE_ASSET__BxREHQWP__"